import '../../assets/styles/modal.css'

const ModalWrapper = ({ children }) => {
  return (
    <div className="modalWrapper">
      {children}
    </div>
  )
}

export default ModalWrapper
